import { useEffect, useRef, useState } from "react";

const VIDEOS = [
  "/videos/hero-1.mp4",
  "/videos/hero-2.mp4",
  "/videos/hero-3.mp4",
  "/videos/hero-4.mp4",
];

// Duración del crossfade (ms). Debe coincidir con la clase "duration-700" del <video>.
const CROSSFADE_MS = 700;
// Segundos antes del final en los que arrancamos el siguiente clip para que solape.
const OVERLAP_S = CROSSFADE_MS / 1000;

export default function VideoHero({ className = "", posterFallback }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const videoRefs = useRef([]);
  const advancingRef = useRef(false);

  // Arrancar el primer vídeo al montar
  useEffect(() => {
    const first = videoRefs.current[0];
    if (first) {
      first.play().catch(() => {
        // Autoplay bloqueado por el navegador — sin sonido siempre debería funcionar
      });
    }
  }, []);

  const handleTimeUpdate = (index) => (e) => {
    if (index !== activeIndex) return;
    const v = e.currentTarget;
    if (!v.duration || isNaN(v.duration)) return;
    if (advancingRef.current) return;

    if (v.currentTime >= v.duration - OVERLAP_S) {
      advancingRef.current = true;
      const nextIndex = (index + 1) % VIDEOS.length;
      const nextVideo = videoRefs.current[nextIndex];
      if (nextVideo) {
        nextVideo.currentTime = 0;
        nextVideo.play().catch(() => {});
      }
      setActiveIndex(nextIndex);

      // Reset the current video so it's ready when it becomes active again
      setTimeout(() => {
        try {
          v.pause();
          v.currentTime = 0;
        } catch {
          // ignore
        }
        advancingRef.current = false;
      }, CROSSFADE_MS + 100);
    }
  };

  return (
    <div className={`relative w-full h-full overflow-hidden bg-slate-900 ${className}`} data-testid="video-hero">
      {VIDEOS.map((src, i) => (
        <video
          key={src}
          ref={(el) => (videoRefs.current[i] = el)}
          poster={posterFallback}
          muted
          playsInline
          preload="auto"
          onTimeUpdate={handleTimeUpdate(i)}
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-700 ease-in-out ${
            i === activeIndex ? "opacity-100" : "opacity-0"
          }`}
        >
          <source src={src.replace(".mp4", ".webm")} type="video/webm" />
          <source src={src} type="video/mp4" />
        </video>
      ))}
    </div>
  );
}
